import { ICandidate } from "../domain/candidate";

export interface ICandidateSorted extends ICandidate {
    display_order: number;

}
export const shuffleCandidates = (candidates: Array<ICandidate>) => {
    const v = candidates
        .map(
            (c: ICandidate): ICandidateSorted => ({
                ...c,
                display_order: Math.random() * 10000,
            })
        );

    return v.sort((a: ICandidateSorted, b: ICandidateSorted) =>
        a.display_order > b.display_order ? -1 : 1
    );
}